import { useState, useCallback } from 'react';
import type { DailyProgress, ProblemType } from '../types';
import { loadDailyProgress, incrementWin as incrementWinStorage } from '../lib/storage';

export function useDailyProgress() {
  const [dailyProgress, setDailyProgress] = useState<DailyProgress>(() =>
    loadDailyProgress()
  );

  const incrementWin = useCallback((category: ProblemType) => {
    const updated = incrementWinStorage(category);
    setDailyProgress(updated);
    return updated;
  }, []);

  const getWins = useCallback(
    (category: ProblemType): number => {
      return dailyProgress.wins[category] || 0;
    },
    [dailyProgress]
  );

  return {
    dailyProgress,
    incrementWin,
    getWins,
  };
}
